const Format = {
    // currency: (v) => ((typeof v === 'string') ? v.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : v),
    currency: (v) => (v.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')),    // 자료형 관계 없이 단위표기 필요
    date: (v) => ((typeof v === 'string') ? v.split(' ')[0] : v),
    head: (v, len = 10) => ((typeof v === 'string') ? v.substr(0, len) : v),
};

export default Format;